import React, { useState, useEffect } from 'react'
import { Tooltip, Badge } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import fetchAPI from '../../../../lib/utils/fetch-api'
import { Note, NotesCellProps } from './interfaces'
import { IconWrapper, NotesContent, NoteItem, NoteHeader, NoteText, CellWrapper } from './styles'

export const NotesCell: React.FC<NotesCellProps> = ({ cardId, count, cardType = 'case' }) => {
  const [notes, setNotes] = useState<Note[]>([])
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (open && notes.length === 0 && count && count > 0) {
      fetchNotes()
    }
  }, [open, cardId, cardType])

  const fetchNotes = async () => {
    setLoading(true)
    try {
      const response = await fetchAPI(`/api/notes/${cardType}/${cardId}`)
      if (response?.data) {
        setNotes(response.data)
      }
    } catch (error) {
      console.error('Failed to fetch notes:', error)
    } finally {
      setLoading(false)
    }
  }

  const notesContent = (
    <NotesContent>
      {loading && <div>Загрузка...</div>}
      {!loading && notes.length === 0 && <div>Нет заметок</div>}
      {!loading &&
        notes.length &&
        notes.map(note => (
          <NoteItem key={note.id}>
            <NoteHeader>
              <span>{note.user_name}</span>
              <span>{dayjs(note.created_at).format('DD.MM.YYYY HH:mm')}</span>
            </NoteHeader>
            <NoteText dangerouslySetInnerHTML={{ __html: note.note }} />
          </NoteItem>
        ))}
    </NotesContent>
  )

  if (!count || count === 0) {
    return null
  }
  return (
    <CellWrapper onClick={e => e.stopPropagation()}>
      <Tooltip
        title={notesContent}
        placement="right"
        trigger="hover"
        onOpenChange={setOpen}
        styles={{ root: { maxWidth: '450px' } }}
        color="#262626"
      >
        <Badge count={count} showZero={false} overflowCount={99} size={'small'}>
          <IconWrapper>
            <FileTextOutlined />
          </IconWrapper>
        </Badge>
      </Tooltip>
    </CellWrapper>
  )
}
